import angular from 'angular';
import moment from 'moment';

window.angular = angular;

window.moment = moment;
window.CareLineLive = window.CareLineLive || {};

export function bootstrapLocale() {
    const locale = window.CareLineLive.js_locale;

    if (!locale) {
        return Promise.resolve();
    }

    const scripts = [loadScript(`/dist/locale/angular-locale_${locale}.js`)];

    // Moment's default locale is en-us, so no locale file is needed
    if (locale !== 'en-us') {
        scripts.push(loadScript(`/dist/locale/moment-locale_${locale}.js`));
    }

    return Promise.all(scripts).catch(error => {
        console.error(error);
    });
}

function loadScript(url) {
    return new Promise((resolve, reject) => {
        const script: any = document.createElement('script');
        const element: any = document.getElementsByTagName('body')[0];
        let removed = false;

        script.type = 'text/javascript';

        if (script.readyState) {
            // IE
            script.onreadystatechange = function () {
                if (script.readyState === 'complete' || script.readyState === 'loaded') {
                    script.onreadystatechange = null;

                    setTimeout(() => {
                        if (removed) {
                            return;
                        }
                        removed = true;
                        element.removeChild(script);
                        resolve();
                    }, 30);
                }
            };
        } else {
            // Others
            script.onload = function () {
                if (removed) {
                    return;
                }
                removed = true;
                element.removeChild(script);
                resolve();
            };

            script.onerror = error => {
                if (removed) {
                    return;
                }

                console.error('Unable to load script', error);

                removed = true;
                element.removeChild(script);
                reject();
            };
        }

        script.src = url;
        script.async = true;
        element.appendChild(script);
    });
}
